import { OrganizationComponent } from "../../components/OrganizationComponent/OrganizationComponent"

export const CommonOrganization = () => {
    return (
        <OrganizationComponent 
            isAdminPage={false}
        />
    )
} 